<template>
    <BaseModal :isShow="isShow" @close="emit('close')" size="md">
        <div class="flex flex-col w-full p-6 gap-4">
            <div class="">مشتری گرامی، جهت برقراری تماس خروجی و دایورت خط، به اعتبار اولیه نیاز است!</div>
            <div class="[&>*]:w-full [&>*]:my-1 laptop:flex laptop:justify-between laptop:[&>*]:w-[48%]">
                <BaseButton styleType="secondary" isLean size="full" text="افزایش اعتبار" @click="emit('close')" />
                <BaseButton isLean size="full" text="ادامه خرید بدون اعتبار اولیه" @click="confirm"/>
            </div>
        </div>
    </BaseModal>
</template>
  
<script setup>
const props = defineProps({
    isShow: Boolean
})

const emit = defineEmits(['close', 'confirm'])

const confirm = () => {
    emit('confirm')
    emit('close')
}

</script>